import BankData from '@aboutyou/legacy-shared/src/pages/AccountArea/BankData/BankDataPage.desktop'
import TrackContentPageView from '@aboutyou/legacy-shared/src/tracking/trackerComponents/TrackContentPageView'
import { MissionBadgeType } from '@aboutyou/legacy-shared/src/types/missions'
import { BICTranslations } from '@aboutyou/legacy-shared/src/ui/CodBankData/components/FormContent'
import { TrackingPageTypeWithoutId } from '@aboutyou/legacy-tracking-sdk'
import { useRouter } from 'helpers/navigation'
import { ConnectedSharedPageTrackingContextProvider } from 'helpers/tracking/ConnectedSharedPageTrackingContextProvider'
import { useDesktopSafeguardedTrackingPageContextProps } from 'helpers/tracking/PageTrackingContext'
import { useTrackingPageUrl } from 'helpers/tracking/hooks/useTrackingPageUrl'
import { useTrackingCustomer } from 'helpers/tracking/trackerComponents/TrackCustomer'
import React from 'react'
import useAccountAreaNavigationProps from './useAccountAreaNavigationProps'
import { useBankDataPageTranslations } from './useBankDataPageTranslations'
import { useBankDetailsTranslations } from './useBankDetailsTranslations'

function ConnectedBankDataPage({
  favouritePageLabel,
  bicTranslations,
  MissionBadge,
}: {
  favouritePageLabel: string
  bicTranslations: BICTranslations
  MissionBadge: MissionBadgeType
}) {
  const { navigateClient } = useRouter()

  const { path, search } = useTrackingPageUrl()

  const navigationProps = useAccountAreaNavigationProps(favouritePageLabel)
  const bankDetailsTranslations = useBankDetailsTranslations()
  const bankDataPageTranslations = useBankDataPageTranslations()

  const pageContextProps = useDesktopSafeguardedTrackingPageContextProps({
    path,
    search,
    type: TrackingPageTypeWithoutId.BankDataCOD,
  })
  const trackingCustomer = useTrackingCustomer()

  return (
    <ConnectedSharedPageTrackingContextProvider {...pageContextProps}>
      <TrackContentPageView trackingCustomer={trackingCustomer} />
      <BankData
        bankDetailsTranslations={bankDetailsTranslations}
        bicTranslations={bicTranslations}
        bankDataPageTranslations={bankDataPageTranslations}
        navigateClient={navigateClient}
        MissionBadge={MissionBadge}
        {...navigationProps}
      />
    </ConnectedSharedPageTrackingContextProvider>
  )
}

export default ConnectedBankDataPage
